<template lang="pug">
  .m-top-5.row.width-100.center.middle
    token-error(
      :title='$t("token.usedTokenTitle")'
      :message='$t("token.usedTokenMessage")'
    )
</template>

<script>
import TokenError from '@/components/TokenError'

export default {
  name: 'UsedToken',
  components: { TokenError }
}
</script>
